import z from 'zod';

export const AssistantComposerSchema = z.object({
    msg: z.string().trim().min(1, '')
});

export type AssistantComposerFormValues = z.infer<typeof AssistantComposerSchema>;

